/* tslint:disable */
import { Injectable } from "@angular/core";

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: "root",
})
export class ApiConfiguration {
  rootUrl: string = "http://localhost:52846";
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
